import dataService from "flow/data/service";
import MyFlow from "flow/MyFlow";

export default function clearSelectedProductFromUserSettings(myFlow: MyFlow): JQueryPromise<void> {
    return dataService.clearSelectedProduct(myFlow);
}
